export const setCookieTokenRoute = '/next-api/auth/set-token';
export const stockVehicleImageRoute = '/next-api/stock-vehicle-image';
